/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "submityourclaimapi",
            "endpoint": "https://ru5l1sx8y1.execute-api.us-west-2.amazonaws.com/staging",
            "region": "us-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-west-2:f961d104-3e6b-44e5-b728-c81d0c686526",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_vmxkTFd8Q",
    "aws_user_pools_web_client_id": "5tet8k7dd7736g37q954phbf0",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "submityourclaim16ff83b99b1b4eeeb0d41905813e3f9d233037-staging",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
